import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "../shared/auth/AuthContext";
import { signInWithApple, signInWithGoogle } from "../shared/auth/firebaseAuth";

function safeNextPath(raw: string | null): string {
  // next 未指定ならいちごスタディへ (トップ / も /study へ寄せている)
  if (!raw) return "/study";
  try {
    const decoded = decodeURIComponent(raw);
    if (decoded.startsWith("/") && !decoded.startsWith("//")) {
      return decoded;
    }
  } catch {
    /* fallthrough */
  }
  return "/study";
}

export function LoginRoute() {
  const auth = useAuthState();
  const navigate = useNavigate();
  const location = useLocation();
  const [submitting, setSubmitting] = useState<"google" | "apple" | null>(null);
  const [error, setError] = useState<string | null>(null);

  const next = safeNextPath(new URLSearchParams(location.search).get("next"));

  useEffect(() => {
    if (auth.status === "authenticated") {
      navigate(next, { replace: true });
    }
  }, [auth.status, navigate, next]);

  if (auth.status === "authenticated") {
    return <Navigate to={next} replace />;
  }

  const handleGoogle = async () => {
    setError(null);
    setSubmitting("google");
    try {
      await signInWithGoogle();
    } catch (err: unknown) {
      console.error("[auth] Google sign-in failed", err);
      setError("ログインに失敗しました。時間を置いて再度お試しください。");
      setSubmitting(null);
    }
  };

  const handleApple = async () => {
    setError(null);
    setSubmitting("apple");
    try {
      await signInWithApple();
    } catch (err: unknown) {
      console.error("[auth] Apple sign-in failed", err);
      setError("ログインに失敗しました。時間を置いて再度お試しください。");
      setSubmitting(null);
    }
  };

  return (
    <section>
      <h1 style={{ marginTop: 0 }}>ログイン</h1>
      <p style={{ color: "var(--color-text-sub)" }}>
        Berry Buds モバイルアプリと同じアカウントでログインしてください。
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-3)",
          marginTop: "var(--space-5)",
          maxWidth: 360,
        }}
      >
        <button
          type="button"
          onClick={handleGoogle}
          disabled={submitting !== null}
          style={{
            backgroundColor: "var(--color-surface)",
            color: "var(--color-text)",
            border: "1px solid var(--color-border)",
            borderRadius: "var(--radius)",
            padding: "var(--space-3) var(--space-5)",
            cursor: submitting !== null ? "wait" : "pointer",
          }}
        >
          {submitting === "google" ? "ログイン中..." : "Google でログイン"}
        </button>
        <button
          type="button"
          onClick={handleApple}
          disabled={submitting !== null}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            border: "1px solid #000",
            borderRadius: "var(--radius)",
            padding: "var(--space-3) var(--space-5)",
            cursor: submitting !== null ? "wait" : "pointer",
          }}
        >
          {submitting === "apple" ? "ログイン中..." : "Apple でログイン"}
        </button>
      </div>
      {error !== null ? (
        <p role="alert" style={{ color: "var(--color-accent)", marginTop: "var(--space-4)" }}>
          {error}
        </p>
      ) : null}
    </section>
  );
}
